import iMISFetch from "@/utils/iMISFetch";
import { IQA_LOGGED_IN_USER, QUERY_ENDPOINT } from "@/store/constants";
import type { LoggedInUser } from "@/store/types";

interface RawRow {
  ID?: string;
  IsMember?: boolean | string;
}

/**
 * GET /api/query?queryname=$/ASI/Store/LoggedInUser
 *
 * Returns the logged-in user's ID and membership flag, which decides whether
 * member or non-member (standard) pricing is displayed. Returns null on a
 * successful-but-empty response (caller then defaults to non-member pricing);
 * throws on network/5xx.
 */
export async function fetchLoggedInUser(): Promise<LoggedInUser | null> {
  const result = await iMISFetch<RawRow>(QUERY_ENDPOINT, { query: IQA_LOGGED_IN_USER, limit: 0 });
  if (!result.success) {
    throw new Error(`fetchLoggedInUser failed: ${result.message || "unknown error"}`);
  }
  const rows = Array.isArray(result.data) ? (result.data as RawRow[]) : [];
  if (rows.length === 0) return null;
  const row = rows[0];
  return {
    id: String(row.ID ?? ""),
    // iMIS may project the boolean as true/false or the strings "true"/"false".
    isMember: row.IsMember === true || row.IsMember === "true",
  };
}
